<template>
  <div class="normap">
    <div v-if='!tit'>/</div>
    <a-popover :content="tit" v-else>
      <div class="norTie">{{tit}}</div>
    </a-popover>
  </div>
</template>
<script>
export default {
  props: {
    tit: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.norTie {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>